import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }

import { date } from "quasar"
import SfxCard from "src/components/card/SfxCard.vue"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardEventBase',
  props: {
  title: {
    type: String,
    required: true,
  },

  createdDate: {
    type: String,
    required: true,
  },

  manager: {
    type: Boolean,
    default: false,
  },

  titleClass: {
    type: String,
  },

  clickable: {
    type: Boolean,
    default: false,
  },

  noContent: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

// `createdDateTime` can be either created date of Issue, CorrectiveWork, WorkOrder etc. Or it can be
// the created date of the EventCard. Meaning the date time of the action which resulted in the relevant EventCard
const createdDateTime = computed(() => date.formatDate(props.createdDate, DATE_TIME_FULL_MASK))
const titleClass = computed(() => [props.manager ? "text-h4" : "text-h6", props.titleClass ?? ""])
const createdDateClass = computed(() => (props.manager ? "text-subtitle1" : "text-subtitle2"))
const contentClass = computed(() =>
  props.manager && !props.noContent ? "q-gutter-y-sm q-mt-sm" : ""
)

//endregion

//region Functions

function handleClick() {
  emit("click")
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createBlock(SfxCard, {
    class: "sfx-card-issue-status",
    clickable: props.clickable,
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(titleClass.value)
        }, _toDisplayString(__props.title), 3),
        _createVNode(_component_q_space),
        _createElementVNode("span", {
          class: _normalizeClass(createdDateClass.value)
        }, _toDisplayString(createdDateTime.value), 3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(contentClass.value)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _: 3
  }, 8, ["clickable"]))
}
}

})